import actionTypes from '../constants/action-types';

const authenticate = () => ({
  type: actionTypes.AUTHENTICATE,
});

export default authenticate;
